export default __webpack_public_path__ + "static/media/fearimmunity.7e8e0af0.png";